<div class="nms-success-rate">
  <mat-progress-bar
    class="nms-success-rate__bar nms-success-rate__bar--mock"
    mode="determinate"
    [value]="percentage()"
    [attr.aria-valuenow]="percentage()"
    aria-label="Session success rate" />
  <span class="nms-success-rate__value font-medium">{{ percentage() }}%</span>
</div>
